// extracted by mini-css-extract-plugin
export default {"Hamburger":"HamburgerIcon_Hamburger__bdACb","swing-in":"HamburgerIcon_swing-in__dmd0z"};